import { RootState } from 'store/store';

export const selectSearchWorkspaces = (state: RootState) => state.Search.workspaces;
export const selectLastSearchKey = (state: RootState) => state.Search.lastSearchKey;
